module.exports = __webpack_public_path__ + "static/media/201ME131.aa863646.jpg";